import type { ComponentPropsWithRef, ReactNode } from 'react';

type FieldProps = ComponentPropsWithRef<'input'> & {
  label: ReactNode;
  error?: string | undefined;
};

/**
 * Campo de formulário com rótulo e mensagem de erro amarrados por `aria`.
 * A mensagem diz o que corrigir, não apenas que algo está errado.
 *
 * Aceita `ref` como prop comum (React 19), o que permite passar direto o
 * resultado de `register()` do React Hook Form.
 */
export function Field({ label, error, id, ...inputProps }: FieldProps) {
  const errorId = error ? `${id}-error` : undefined;

  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={id} className="text-xs tracking-[0.12em] text-ink-soft uppercase">
        {label}
      </label>

      <input
        {...inputProps}
        id={id}
        aria-invalid={error ? true : undefined}
        aria-describedby={errorId}
        className="border border-clay bg-white px-3 py-2.5 text-sm transition-colors focus:border-brand-600 focus:outline-none aria-invalid:border-brass"
      />

      {error && (
        <p id={errorId} role="alert" className="text-xs text-brass">
          {error}
        </p>
      )}
    </div>
  );
}
